import { useState } from 'react';
import { RegistrationRecord } from 'src/models/data-registration/RegistrationRecord';
import ServiceCollection from 'src/services/ServiceCollection';

export function useSearchByBeatAndStage(services: ServiceCollection) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>();

  const getRegistrationRecords = async (
    beat: string,
    approvalWorkflowStage: string,
    nextToken?: string,
    pageSize?: number,
  ): Promise<{
    registrationRecords?: RegistrationRecord[];
    nextPageToken?: string;
    error?: string;
  }> => {
    setLoading(true);
    setError(undefined);

    try {
      const result = await services.registrationDataService.getRecordsByBeatAndApprovalWorkflowStage(
        beat,
        approvalWorkflowStage,
        nextToken,
        pageSize,
      );
      return result;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'An error occurred while searching records';
      setError(errorMessage);
      return { error: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    getRegistrationRecords,
  };
}
